/* Inscription à la lettre : validation du courriel et de la case de consentement avant l'envoi, état « envoi en cours ».
   Maquette : js/sections/h14_newsletter.js (la maquette simulait le succès ; ici l'envoi est le formulaire natif Shopify, rien n'est intercepté après validation).
   Amélioration progressive : sans JavaScript, la validation du navigateur (champs required) et le serveur font le travail.
   Réinitialisé dans l'éditeur de thème (shopify:section:load). */
import { $, $$, on } from 'mi/dom';

const valid = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(String(v).trim());

function init(root) {
  if (!root || root.dataset.ready) return;
  const form = $('form', root);
  const email = form && $('input[type=email]', form);
  if (!form || !email) return;   // état « inscription réussie » : pas de formulaire
  root.dataset.ready = '1';
  form.noValidate = true;
  const consent = $('input[type=checkbox]', form);
  const err = $('.news__error', root);
  const btn = $('button[type=submit]', form);
  const message = root.dataset.errorText || '';

  const clear = () => { if (err) { err.hidden = true; err.textContent = ''; } email.removeAttribute('aria-invalid'); };
  on(email, 'input', clear);
  /* Copie de l'inscription vers Brevo via le relais (la clé Brevo reste sur le serveur du relais). Silencieux : si le relais ne répond pas,
     l'inscription Shopify suit son cours normalement. keepalive : la requête survit au rechargement de la page après l'envoi. */
  const relay = root.dataset.relay;
  const first = $('input[name="contact[first_name]"]', form);
  const hp = $('[data-hp]', form);
  const sendToBrevo = () => {
    if (!relay || !window.fetch) return;
    try {
      const body = new URLSearchParams({
        email: email.value.trim(),
        prenom: first ? first.value.trim() : '',
        lang: /^en/i.test(document.documentElement.lang || '') ? 'en' : 'fr',
        consent: '1',
        website: hp ? hp.value : ''
      });
      fetch(relay, { method: 'POST', body, mode: 'cors', credentials: 'omit', keepalive: true }).catch(() => {});
    } catch (_) { /* sans effet sur l'inscription Shopify */ }
  };
  on(form, 'submit', (e) => {
    if (!valid(email.value)) {
      e.preventDefault();
      if (err) { err.textContent = message; err.hidden = false; }
      email.setAttribute('aria-invalid', 'true');
      email.focus();
      return;
    }
    if (consent && !consent.checked) { e.preventDefault(); consent.focus(); return; }
    if (btn) { btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true'); }
    sendToBrevo();
  });
  /* Retour arrière du navigateur après un envoi : on rend le bouton utilisable */
  on(window, 'pageshow', () => { if (btn) { btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy'); } });
}

const boot = (scope = document) => $$('[data-news]', scope).forEach(init);
boot();
document.addEventListener('shopify:section:load', (e) => boot(e.target));
